export default __webpack_public_path__ + "static/media/diamond-bg.eb60591e.png";